import React from 'react';
import { Stack, TextField } from '@mui/material';

/** Step 0 — name, symbol, description, cover image. */
export default function StepBasics({ form, setField }) {
  return (
    <Stack spacing='12px'>
      <TextField
        size='small' required
        label='Collection name'
        value={form.name}
        onChange={(e) => setField('name', e.target.value)}
        placeholder='Acme Genesis'
        fullWidth
      />
      <TextField
        size='small' required
        label='Symbol'
        value={form.symbol}
        onChange={(e) => setField('symbol', e.target.value.toUpperCase().slice(0, 12))}
        placeholder='ACME'
        inputProps={{ maxLength: 12 }}
        fullWidth
        helperText='Short ticker shown on marketplaces. Up to 12 chars.'
      />
      <TextField
        size='small'
        label='Description'
        multiline rows={3}
        value={form.description}
        onChange={(e) => setField('description', e.target.value)}
        placeholder='Tell collectors what this collection is about.'
        fullWidth
      />
      <TextField
        size='small'
        label='Cover image URL'
        value={form.cover_image_url}
        onChange={(e) => setField('cover_image_url', e.target.value)}
        placeholder='https://…'
        fullWidth
      />
    </Stack>
  );
}
